module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.woff2";